{
  "supplier": {
    "currencyLoadError": "Currency options could not be loaded. Retry to choose a currency. Your other entries are kept.",
    "currencyKept": "Current currency kept:"
  },
  "agreement": {
    "emptyFiltered": "No agreements match these filters",
    "emptyFilteredHint": "Change or clear the filters to see more agreements.",
    "filterTitle": "Filter agreements",
    "showAgreements": "Show agreements",
    "showCount": "Show agreements: {{count}}",
    "lineOrderable": "Can be ordered now",
    "orderableNow": "Can be ordered now",
    "orderableOnly": "Can be ordered now only",
    "emptyBlocked": "{{reason}}. Nothing can be ordered from this agreement while that is so.",
    "emptyAlsoNoLines": "It also has no priced lines: add one once that is resolved.",
    "emptyReady": "This agreement is in force and its supplier is qualified, but it has no priced lines yet, so nothing can be ordered from it. Add a priced line."
  },
  "unusable": {
    "agreement_no_priced_lines": "No priced lines",
    "agreement_no_orderable_lines": "No line can be ordered now",
    "agreement_item_not_in_catalogue": "Not available in the catalogue"
  },
  "qualification": {
    "reasonField": "Review reason or evidence",
    "reasonRequiredHint": "Required for this decision. Say why, so it can be explained later.",
    "reasonOptionalHint": "Optional. What was checked or why this was decided, for example the documents reviewed. It is saved with the decision, your name and the time.",
    "reviewRequiredHint": "Required for this decision. Say what was checked and what it showed, for example the documents reviewed. It is saved with the decision, your name and the time.",
    "reliesOnReview": "This activation will rely on the review recorded when the qualification was approved:",
    "reliesOnReviewHint": "Optional. Add anything checked since the approval, for example a renewed certificate. It is saved with the decision, your name and the time.",
    "noReasonRecorded": "No reason recorded"
  }
}
